/* global document */
export function querySelectorAllArray(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
}



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/utils/querySelectorAllArray.js